"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledSelect = styled_components_1.default.span `
	display: flex;
	align-items: center;
	justify-items: center;
	padding-left: 8px;
	margin-top: 25px;
	margin-right: 20px;
	border-bottom: ${({ theme }) => `2px solid ${theme.gray3}`};
	position: relative;

	&:focus-within {
		border-bottom-color: ${({ theme }) => `${theme.denimBlue}`};
	}

	label {
		position: absolute;
		top: -22px;
		left: 40px;
		font-size: 14px;
	}

	@media (max-width: 41em) {
		margin-left: 20px;
		margin-right: 20px;
	}

	@media (max-width: 260px) {
		margin-left: 10px;
		margin-right: 10px;
		label {
			left: 0;
		}
	}

	&.invalid {
		border-bottom: ${({ theme }) => `2px solid ${theme.invalidRed}`};
	}

	.icon-span {
		color: ${({ theme }) => theme.gray3};
		margin-bottom: 5px;
		width: 15px;
	}

	select {
		margin-left: 10px;
		border: none;
		height: 20px;
		width: 100%;
		font-size: ${({ theme }) => `${theme.baseFontSize}`};
		color: ${({ theme }) => theme.gray};
		background-color: ${({ theme }) => theme.white};

		&:focus {
			outline: none;
		}

		&.filled {
			color:  ${({ theme }) => theme.black};
		}

		@media (max-width: 41em) {
			font-size: ${({ theme }) => `${theme.smallFontSize}`};
		}
	}
`;
const Select = (props) => {
    const { id, name, className, icon, options, dataTestId, value, onChange, label, ariaRequired } = props;
    return (react_1.default.createElement(StyledSelect, { className: className },
        react_1.default.createElement("span", { className: 'icon-span' }, icon),
        react_1.default.createElement("label", { htmlFor: name },
            label,
            ariaRequired && react_1.default.createElement("span", { "aria-hidden": 'true' }, " *")),
        react_1.default.createElement("select", { id: id, name: name, className: value != null && value.length > 0 ? 'filled' : '', "data-testid": dataTestId, value: value, onChange: onChange, "aria-required": ariaRequired },
            react_1.default.createElement("option", { key: "", value: "" }, label),
            options.map(option => react_1.default.createElement("option", { key: option.value, value: option.value }, option.label)))));
};
exports.Select = Select;
